real.dom.initJquery(jQuery);
